import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useI18n } from "../lib/i18n";

const KEY = "kav_cookie_ack_v1";

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (err) {
      console.error("[cookie] localStorage read failed", err);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, new Date().toISOString());
    } catch (err) {
      console.error("[cookie] localStorage write failed", err);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[10001]"
    >
      <div className="bg-white border border-[#143122]/20 shadow-2xl rounded-xl p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="overline text-[#143122]">{t("cookie_title")}</div>
            <p className="mt-2 text-sm text-[#1A1F1C]/85 leading-relaxed">
              {t("cookie_body")}{" "}
              <Link to="/privacy" className="text-[#143122] underline">
                {t("cookie_learn_more")}
              </Link>
            </p>
          </div>
          <button
            type="button"
            data-testid="cookie-close"
            onClick={accept}
            aria-label="Dismiss"
            className="shrink-0 text-[#1A1F1C]/50 hover:text-[#143122]"
          >
            <X size={16} strokeWidth={1.75} />
          </button>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={accept}
            className="kav-btn-primary text-sm"
          >
            {t("cookie_accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
